export default __webpack_public_path__ + "static/media/quotes-r.d9e07ae6.svg";